module.exports = __webpack_public_path__ + "img/logo_white.ca7d124b.svg";